import { Injectable } from '@angular/core';
import { from, Observable, of, share, switchMap } from 'rxjs';
import { UbieState } from '../../interfaces';
import { ObservableDictionary } from '../ObservableDictionary';
import { BaseCommunicationService } from './base-communication-service';

@Injectable({ providedIn: 'root' })
export class DeviceCommunicationService extends BaseCommunicationService<UbieState> {
  protected readonly createUbieItemFn = (
    ubieSerialNumber: string,
  ): Observable<UbieState> => {
    return this.communicationListenerService
      .getUbieDeviceCommunication(ubieSerialNumber)
      .ubieState$.pipe(share());
  };

  protected readonly deleteUbieItemFn = (ubieSerialNumber: string): void => {
    this.communicationFilterService.disableUbieDevices([ubieSerialNumber]);
  };
  protected override readonly dictionary: ObservableDictionary<UbieState> =
    new ObservableDictionary<UbieState>(
      this.createUbieItemFn,
      this.deleteUbieItemFn,
    );

  enable(ubieSerialNumber: string): Observable<void> {
    return from(
      this.communicationFilterService.enableUbieDevices([ubieSerialNumber]),
    ).pipe(switchMap(() => of()));
  }

  override getOrAddItem(key: string): Observable<UbieState> {
    return this.dictionary.getOrAdd(key);
  }
}
